<template>
  <div class="mapContainer">
    <div class="backTopMap" v-if="mapData.level >= 3 && formDetail.level == 2">
      <el-button type="primary" size="medium" @click="backMap"
        >返回上级地图</el-button
      >
    </div>
    <div id="map" style="width: 100%; height: 100%"></div>
    <!-- <div id="levalMap" style="width: 100%; height: 100%"></div> -->
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getTownList } from "@/api/大数据.js"
export default {
  name: "Map",
  props: {
    formDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      cityList: [],//接口地图展示数据
      cityData: {},//原始数
      xianCityData: {},

      mapData: {
        shiName: '',
        shiValue: '',
        shiDeptId: '',
        xianName: '',
        xianValue: '',
        xianDeptId: '',
        xiangName: '',
        xiangValue: '',
        xiangDeptId: '',
        level: 2,
      },

      myChart: null,

    }
  },
  mounted () {
    this.mapData.level = this.formDetail.level

    if (this.formDetail.level == 2) {
      this.mapData.shiDeptId = this.formDetail.deptId

    } else if (this.formDetail.level == 3) {
      this.mapData.xianDeptId = this.formDetail.deptId

    } else if (this.formDetail.level == 4) {
      this.mapData.xiangDeptId = this.formDetail.deptId

    }
    getTownList(this.formDetail).then(res => {
      this.cityList = res.data.data.map(item => {
        return { name: item.deptName, value: item.deptCode, deptId: item.deptId }
      })


    }).then(() => {
      this.mapLoad()
    })

  },
  methods: {
    mapLoad () {
      let chartDom = document.querySelector('#map')
      this.myChart = echarts.init(chartDom)
      let option, geoJson
      console.log("this.formDetail.deptCode", this.formDetail.deptCode)
      if (this.mapData.level == 2) {
        this.mapData.level = 2
        this.mapData.shiName = this.formDetail.deptName
        this.mapData.shiValue = this.formDetail.deptCode
        geoJson = require(`../../../../public/41/${this.formDetail.deptCode.toString().slice(0, 4)}.json`)
      } else if (this.mapData.level == 3) {

        this.mapData.level = 3
        this.mapData.xianName = this.formDetail.deptName
        this.mapData.xianValue = this.formDetail.deptCode
        geoJson = require(`../../../../public/41/${this.formDetail.deptCode.toString().slice(0, 6)}.json`)
      } else if (this.mapData.level == 4) {

        this.mapData.level = 4
        this.mapData.xiangName = this.formDetail.deptName
        this.mapData.xiangValue = this.formDetail.deptCode
        geoJson = require(`../../../../public/41/${this.formDetail.deptCode.toString().slice(0, 6)}.json`)
      }
      echarts.registerMap('cityMap', geoJson)
      option = {
        selectedMode: "single",
        title: {
        },
        tooltip: {
          show: false
        },
        series: [
          {
            name: '',
            type: 'map',
            map: 'cityMap',
            roam: true,
            label: {
              show: true,
              color: "#fff",
              fontSize: 14,
            },
            data: this.cityList,
            itemStyle: {
              areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#2084F8" },
                { offset: 0.4, color: "#2084F8" },
                { offset: 1, color: "#1C68C1" },
              ]),
              borderColor: "#AFE9FA",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                color: "#fff",
                fontSize: 14,
                show: true
              },
              itemStyle: {
                areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#F6B858" },
                  { offset: 0.4, color: "#FA9E34" },
                  { offset: 1, color: "#FD7B00" },
                ]),
              }
            },
            markPoint: {
              show: true,
              symbol: 'pin',// 自定义图片路径
              label: {
                position: 'top',
                color: '#fff',
                fontSize: 16,
                formatter: "{b}"
              },
              symbolSize: 26,
              itemStyle: {
                color: '#fff'
              },
              emphasis: {
                itemStyle: {
                  color: "#FA9E34"
                },
                label: {
                  color: "#FA9E34",
                  fontWeight: "700"
                }
              },
              data: []
            },
            select: {
              label: {
                color: "#fff",
                fontSize: 14,
              },
              itemStyle: {
                areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#F6B858" },
                  { offset: 0.4, color: "#FA9E34" },
                  { offset: 1, color: "#FD7B00" },
                ]),
              },
            },
          }
        ],
      }
      this.myChart.on("click", (params) => {
        // debugger
        if (this.mapData.level == 2) {
          this.mapData.level = 3
          this.mapData.xianName = params.data.name
          this.mapData.xianValue = params.data.value
          // 赋值县deptID
          this.mapData.xianDeptId = params.data.deptId
          this.myChart.clear()
          getTownList({ deptId: params.data.deptId }).then(res => {
            this.cityList = res.data.data.map(item => {
              return { name: item.deptName, value: item.deptCode, deptId: item.deptId }
            })
            option.series[0].data = this.cityList
          }).then(() => {
            echarts.registerMap('cityMap', require(`../../../../public/41/${this.mapData.xianValue}.json`))
            this.myChart.setOption(option)
          })


          // echarts.registerMap('cityMap', require(`../../../../public/41/${this.mapData.xianValue}.json`));
          // this.myChart.setOption(option);

        } else if ((this.mapData.level == 3) && (this.mapData.xianValue == params.data.value)) {
          this.myChart.dispatchAction({
            type: "downplay",
            seriesIndex: params.seriesIndex,
            name: this.mapData.xianName,
          })
          this.mapData.level = 2
          this.mapData.xianName = ''
          this.mapData.xianValue = ''
        } else if ((this.mapData.level == 4) && (this.mapData.xiangValue == params.data.value)) {
          this.myChart.dispatchAction({
            type: "downplay",
            seriesIndex: params.seriesIndex,
            name: this.mapData.xiangName,
          })
          this.mapData.level = 3

          this.mapData.xiangName = ''
          this.mapData.xiangValue = ''
          this.mapData.xiangDeptId = ''
        } else {
          if (this.mapData.level == 3 || this.mapData.level == 4) {
            this.mapData.level = 4
            this.mapData.xiangName = params.data.name
            this.mapData.xiangValue = params.data.value
            // 赋值乡deptID
            this.mapData.xiangDeptId = params.data.deptId

          }
        }
        this.$emit("mapClickMethod", this.mapData)
      })

      this.myChart.setOption(option)
    },
    backMap () {
      this.mapData.level--
      this.cityData = {}
      this.xianCityData = {}
      this.myChart.clear()
      let option, geoJson
      if (this.mapData.level == 2) {
        geoJson = require(`../../../../public/41/${this.formDetail.deptCode.toString().slice(0, 4)}.json`)
      } else if (this.mapData.level == 3 || this.mapData.level == 4) {
        this.cityData = {
          name: this.formDetail.deptName,
          value: this.formDetail.deptCode
        }
        geoJson = require(`../../../../public/41/${this.formDetail.deptCode.toString().slice(0, 6)}.json`)
      }
      echarts.registerMap('cityMap', geoJson)
      option = {
        selectedMode: "single",
        title: {
        },
        tooltip: {
          show: false
        },
        series: [
          {
            name: '',
            type: 'map',
            map: 'cityMap',
            roam: true,
            label: {
              show: true,
              color: "#fff",
              fontSize: 14,
            },
            data: this.cityList,
            itemStyle: {
              areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#2084F8" },
                { offset: 0.4, color: "#2084F8" },
                { offset: 1, color: "#1C68C1" },
              ]),
              borderColor: "#AFE9FA",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                color: "#fff",
                fontSize: 14,
                show: true
              },
              itemStyle: {
                areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#F6B858" },
                  { offset: 0.4, color: "#FA9E34" },
                  { offset: 1, color: "#FD7B00" },
                ]),
              }
            },
            markPoint: {
              show: true,
              symbol: 'pin',// 自定义图片路径
              label: {
                position: 'top',
                color: '#fff',
                fontSize: 16,
                formatter: "{b}"
              },
              symbolSize: 26,
              itemStyle: {
                color: '#fff'
              },
              emphasis: {
                itemStyle: {
                  color: "#FA9E34"
                },
                label: {
                  color: "#FA9E34",
                  fontWeight: "700"
                }
              },
              data: []
            },
            select: {
              label: {
                color: "#fff",
                fontSize: 14,
              },
              itemStyle: {
                areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#F6B858" },
                  { offset: 0.4, color: "#FA9E34" },
                  { offset: 1, color: "#FD7B00" },
                ]),
              },
            },
          }
        ],
      }
      this.myChart.setOption(option)

    }
  },
}
</script>

<style lang="scss" scoped>
.mapContainer {
  width: 683px;
  height: 570px;
  /* width: 100%;
    height: 100%; */
  /* background-color: aliceblue; */
  position: relative;
}

.backTopMap {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
}
</style>